// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__Qyo8p","footer":"Form_footer__1nbuX"};